export const BLOCKCHAIN_ADDRESS_REGEXP = /^[1-9A-HJ-NP-Za-km-z]{35}$/;
export const SMARTKEY_DESCRIPTION_FORMAT =
  /^[1-9A-HJ-NP-Za-km-z]{35}_[0-9]{13,}$/;
